import React from 'react';
import { Box, Typography } from '@mui/material';
import TeamSettingsHeader from 'team/components/settings/TeamSettingsHeader';
import TeamSettingsList from 'team/components/settings/TeamSettingsList';
import TeamSettingsForm from 'team/components/settings/TeamSettingsForm';

const TeamSettingsContainer = () => {
    return (
        <Box sx={{ p: 3 }}>
            <TeamSettingsHeader />
            <TeamSettingsList />
            <TeamSettingsForm />
        </Box>
    );
};

export default TeamSettingsContainer;
